import {_error, _warning, message} from "./main";
import {createServerInfo, delay, isMobile, reloadContentAll} from "./main_ptx";
import {contentSel, filterSel, initCommon, initFilter, initMessages, mainSel, openUrl, reloadCurrent} from "./main_page";
import {hideCurrent, initialize} from "./main_modal";
import {currentTabId, initTab, removeTab} from "./main_tabs";
import {removeErrors} from "./main_form";

/**
 *callback for place response from server into page and init it
 * @alias Ptx.page.placeResponse
 * @param msg - data info
 * @param srv - server info
 */
export function placeResponse(msg, srv) {
	var forceReload = ((typeof srv.forceReload != 'undefined') ? srv.forceReload : false); 
	if (forceReload) {
		forceReloadPage();
		return;
	}

	var mainContent = $(mainSel);
	var outPageContent = $(contentSel, mainContent);
	var outFilter = $(filterSel);
	var msgTrim = msg.trim();
	var resp = $('<div/>').html(msgTrim);
	var filter = $('#filter', resp).html();
	var pageContent = $('#content', resp);
	
	outPageContent.html(pageContent);
	// during statistics processing, the StatisticsException can be thrown. This exception breaks standard request processing.
	// We have to ensure that no additional JS events are processed and the page remains as it was...
	// Otherwise all buttons inside filter part would have theirs JS events cloned (doubled)
	var pageContentOnlyHeader = srv.xhr.getResponseHeader('Ptx-Page-Content-Only');
	if (!pageContentOnlyHeader) {
		outFilter.html(filter);
		pageResponse();
	}
}

/**
 * callback for page response after load
 * @alias Ptx.page.pageResponse
 */
export function pageResponse(){
	/**
	 * Continue with initialization must be performed after initialization of messages is done (in then() function after promise returned).
	 * If not, then following initialization fails by malfunction of jQuery "datatables.net" library with error message:
	 * "Cannot set properties of undefined (setting '_DT_CellIndex')" see (PX-3302 issue)
	 * while calling of function $this.DataTable(tableSettings); inside initCommon(mainContent) -> initTables(ctx) function!
	 * DEV NOTES: Unfortunately, moving of same structure as below into main_page.js leads to malfunction of "datatables.net" again! So do not touch it!
	 */
	initMessages().then(success => {
		_afterInitMessages();
	}, error => {
		console.error("Error while initialization of messages (" + error + ")");
		_afterInitMessages();
	});
}

function _afterInitMessages() {
	const mainContent = $(mainSel);
	initCommon(mainContent);
	initFilter(mainContent);
	
	// replace title
	var pageTitle = $('#pageTitle').html();
	$('title').html(pageTitle);

	if (isMobile()){
		/* replace mobile title*/
		$('#mobileTitle').html(pageTitle);
		
		var unit = $( "#filterUnitId" );
		if ( unit.length ) {
			if (unit.val() == 0) {
				$("#page-filter, #panel-menu-overlay").addClass("active");
			} else {
				$('#mobileTitle').append('<small class="d-block">'+unit.find('option:selected').text()+'</small>'); // insert name of selected unit
			}
		}
	}
	
	//init page
	if (Ptx.page.ctx.onload) {
		Ptx.page.ctx.onload(mainContent);
	} 
	
	//init included components
	if (Ptx.page.ctx.onloadComponents.length) {
		for(var i=0;Ptx.page.ctx.onloadComponents.length>i;i++){
			Ptx.page.ctx.onloadComponents[i](mainContent);
		}
	}
}


/**
 * Simple callback that only shows messages
 * @alias Ptx.fn.jsonMessageBoxCallback
 */
export function jsonMessageBoxCallback(data, srv) {
	if (data.submitFinal && !data.withoutMessage) {
		if (data.status == 'ok') {
			var permanent = ((typeof data.permanentMessage != 'undefined') ? data.permanentMessage : false);
			if (permanent) { //make it sticky
				message(data.finalMsg, data.detail, "success", true, 60000);
			} else {
				message(data.finalMsg);
			}
		} else if (data.status == 'warn') {
			message(data.finalMsg, data.detail, "warning", true, 60000);
		} else {
			_error(data.finalMsg, data.detail);
		}
	}
}

/**
 * default callback for callUrl
 * @alias Ptx.fn.defaultJsonCallback
 */
export function defaultJsonCallback(data, srv) {
	var forceReload = ((typeof data.forceReload != 'undefined') ? data.forceReload : false);
	jsonMessageBoxCallback(data, srv);
	if (data.submitFinal) {
		if (data.status == 'ok') {
			if (forceReload) {
				forceReloadPage();
				return;
			}
		} 
		if (data.redirectUrl) {
			openUrl(data.redirectUrl);
		} else {
			reloadCurrent();
		}
	}
}

/**
 * default callback after modal form submit, hide form and refresh page
 * if submit was finished, otherwise init modal window again
 * @alias Ptx.modal.form.defaultCallback
 * @param data - data from server
 * @param srv - server info
 * @param tgt
 * @param hide - hide modal if true
 */
export function defaultCallback(data, srv, tgt, hide) {
	var finalS = false;
	var forceReload = false;
	var onlyShowMessage = false;
	if (srv.isJson) {
		finalS = data.submitFinal;
		forceReload = ((typeof data.forceReload != 'undefined') ? data.forceReload : false);
		onlyShowMessage = data.onlyShowMessage;
	}
	if (finalS) {
		jsonMessageBoxCallback(data, srv);
		if (srv.xhr.status == 200 && !onlyShowMessage) {
			removeErrors(tgt);
			if (forceReload) {
				forceReloadPage();
				return;
			}
			
			if (data.redirectUrl) {
				openUrl(data.redirectUrl);
				return;
			} else {
				if (hide){
					hideCurrent();
					if(!$('#extraModal').length > 0) {
						reloadCurrent();
					}
				}
			}
		}
	} else {
		initialize($(tgt));
	}
}

/**
 * callback for modal tabs, that handles submit
 * @alias Ptx.modal.modalTabSubmitCallback
 * @param data - return from server
 * @param srv - server info
 * @param contentId - tab content selector
 * @param returnTabIndex  - optional, to which tab switch after close, defaults to 0
 */
export function modalTabSubmitCallback(data, srv, contentId, returnTabIndex) {
	if (srv.isJson) {
		if (data.submitFinal)
			if (data.status == 'ok') {
				message(data.finalMsg);
			} else {
				_warning(data.finalMsg);
			}
			var tabId = currentTabId($(contentId));

		if(typeof data.removeTab === 'undefined' || data.removeTab !== false)
				removeTab(tabId, Ptx.modal.ctx.window, Ptx.modal.ctx.lastTab);

			reloadContentAll(Ptx.modal.ctx.window);
			if(typeof Ptx.modal.ctx.onTabClose === "function")
				Ptx.modal.ctx.onTabClose(data, srv, tabId);
	} else {
		initTab($(contentId));
	}
}

export function jsonDownloadCallback(data, srv) {
	let contentDispositions = srv.xhr.getResponseHeader('Content-Disposition').split(';').map((part) => part.trim());

	let isAttachment = contentDispositions.some(c => c.includes('attachment'));

	if (isAttachment) {
		let splits = contentDispositions.split(';').map((part) => part.trim());
		let fileName = splits.find((split) => split.startsWith('fileName=\"')).replace('fileName=\"', '');
		let blob = new Blob([JSON.stringify(data, null, 2)], {type: svr.xhr.getResponseHeader('Content-Type')});

		let aTag = $('<a/>').attr('href', window.URL.createObjectURL(blob)).attr('download', fileName);
		aTag.trigger('click');
	}
}

/**
 * See jQuery.ajax for error handler, url param is custom
 * @alias Ptx.fn.defaultErrCallback
 * @param xhr
 * @param textStatus
 * @param error
 * @param url
 * @param loader selector of element to hide
 * @param params
 */
export function defaultErrCallback(xhr, textStatus, error, url, loader, params) {
	$(loader).addClass('hidden');

	if (xhr.status == 401) {
		forceReloadPage();
	} else if(xhr.status == 403) {
		_warning(Ptx.getMsg('security.authorityToPerformOperationExpiredReloadingPage'));
		delay(2000, forceReloadPage);
	} else {
		//asi 500
		var svr = createServerInfo(textStatus, xhr, url, false, params)
		var msg = "";
		if (svr.isJson) {
			var json = JSON.parse(xhr.responseText);
			msg = json.detail;
		} else if (svr.isHtml) {
			//msg = 'See logs for detail';
		}

		var message = xhr.status + ' - '+xhr.statusText;
		message += '<br />'+msg;
		_error('Error', message);
	}
}

/**
 * Make force reload of page and remove request attributes from query string
 * @alias Ptx.fn.forceReloadPage
 */
export function forceReloadPage() {
	//remove hash if present in url, in case of modal
	var loc = window.location.href;
	//remove query string
	var n = loc.indexOf('?');
	loc = loc.substring(0, n != -1 ? n : loc.length);
	//remove fragment if present
	n = loc.indexOf('#');
	loc = loc.substring(0, n != -1 ? n : loc.length);
	
	window.location = loc;
}

/**
 * This function tells the backend that data is ready for stat-export (useful in case of animated elements such as charts). Not using this may cause
 * the drawn data to be incomplete.
 * @alias Ptx.fn.setReadyForExport
 */
export function setReadyForExport() {
	setTimeout(function() {Ptx.allDataLoaded = true;}, 1000)
}